import React, { useCallback } from 'react'
import { Grid } from 'semantic-ui-react'
import DropDown from '@commonComponents/formComponents/CustomDropDown'
import InputField from '@commonComponents/formComponents/CustomInputField'
import { useDispatch, useSelector } from 'react-redux'
import { selectActiveTranTypeList } from '../selectors'

export const ActiveTransportForm = React.memo(
  ({
    dataSource: { id, type, nationality, identification },
    tableName,
    countryList,
    onChange,
    onBlur,
    onSelect,
    repeatableValidationMethods: { validateError, updateErrors },
    disabled,
    translate
  }) => {
    const dispatch = useDispatch()


    const onChangeHandler = useCallback(
      ({ target: { value, name } }) =>{ 
        onChange(id, tableName, { [name]: value })
        if (!validateError || !updateErrors) return null
        const errors = dispatch(
          validateError('transportReducer', 'activeTransportMeansList', 'ACTIVE_TRANS_MEANS')
        )  
      updateErrors(errors, ['ACTIVE_TRANS_MEANS'])
        },
      [tableName, id, onChange]
    )
    const onDropDownChange = useCallback(
      (e, { value, name }) => {
        onSelect(id, tableName, { [name]: value, id })
        if (!validateError || !updateErrors) return null
        const errors = dispatch(
          validateError('transportReducer', 'activeTransportMeansList', 'ACTIVE_TRANS_MEANS')
        )  
      updateErrors(errors, ['ACTIVE_TRANS_MEANS'])
      },
      [tableName, id, onSelect, validateError, updateErrors]
    )
    const onBlurHandler = useCallback(
      ({ target: { value, name } }) =>{ 
        onBlur(tableName, { [name]: value, id })
        if (!validateError || !updateErrors) return null
        const errors = dispatch(
          validateError('transportReducer', 'activeTransportMeansList', 'ACTIVE_TRANS_MEANS')
        )  
      updateErrors(errors, ['ACTIVE_TRANS_MEANS'])
      },
      [tableName, id, onBlur]
    )
    const activeTranTypeList = useSelector(selectActiveTranTypeList)
    return (
      <Grid.Row>
        <Grid.Column>
          <DropDown
            id={`type-${id}`}
            clearable
            name='type'
            label='TYPE'
            data={activeTranTypeList}
            onChange={onDropDownChange}
            value={type}
            text={type}
            isDisabled={disabled}
          />
        </Grid.Column>
        <Grid.Column>
          <InputField
            id={`identification-${id}`}
            name='identification'
            type='text'
            label='ID_NUMBER'
            onChange={onChangeHandler}
            onBlur={onBlurHandler}
            value={identification}
            isDisabled={disabled}
          />
        </Grid.Column>
        <Grid.Column>
          <DropDown
            id={`nationality-${id}`}
            clearable
            name='nationality'
            label='NATIONALITY'
            data={countryList}
            onChange={onDropDownChange}
            value={nationality}
            text={nationality}
            isDisabled={disabled}
          />
        </Grid.Column>
      </Grid.Row>
    )
  }
)
